<template>
  <div>
    <div id="nav" class="header-area top-menu-fixed">
      <div class="top-menu">
        <a class="logo" href="https://freedom-vrn.ru" />
        <a class="mr-4 logo-swift" href="https://freedom-vrn.ru" />

        <a id="top-menu-toggler" class="my-auto" @click="expand">
          <span></span>
        </a>

        <ul class="top-menu-row top-menu-l my-auto mr-auto">
          <li>
            <router-link
              to="/"
              class="topmenu-link mr-3"
              exact-active-class="active"
            >
              Главная
            </router-link>
            <router-link
              to="/services"
              class="topmenu-link mr-3"
              :class="$route.name === 'services' ? 'active' : ''"
            >
              Услуги
            </router-link>
            <router-link
              to="/history"
              class="topmenu-link mr-3"
              exact-active-class="active"
            >
              История
            </router-link>
          </li>
        </ul>

        <ul class="top-menu-row ml-auto my-auto" v-if="client">
          <li class="mr-3 d-flex align-items-center">
            <div class="mr-3 gray">
              Номер л/c - {{ client.clientGroup[0].clientId }}, номер договора -
              {{
                client.clientGroup[0].contracts[0].contractNumber ||
                client.clientGroup[0].contracts[0].number
              }}
            </div>
            <router-link
              to="/logout"
              class="topmenu-link"
              exact-active-class="active"
            >
              Выход
            </router-link>
          </li>
        </ul>

        <!-- <ul class="top-menu-row my-auto">
          <li>
            <lk-button @click="backCallClick">Обратный звонок</lk-button>
          </li>
        </ul> -->
      </div>

      <div class="top-menu-expanded scroll">
        <div class="row">
          <div class="col-12 px-0">
            <ul class="topmenu-column border-t-full py-4">
              <li>
                <router-link to="/" class="font-rem-15" @click="expand">
                  Главная
                </router-link>
              </li>
              <li>
                <router-link
                  to="/services/1"
                  class="font-rem-15"
                  @click="expand"
                >
                  Услуги
                </router-link>
              </li>
              <li>
                <router-link to="/history" class="font-rem-15" @click="expand">
                  История
                </router-link>
              </li>
              <li>
                <router-link to="/logout" class="font-rem-15" @click="expand">
                  Выйти
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from 'lodash'

//import LkParentBase from './controls/LkParentBase.vue'
//import LkChildBase from './controls/LkChildBase.vue'
//import BackCallDialog from './BackCallDialog.vue'
// import SpeedIncrease_2021_03 from './additional/SpeedIncrease_2021_03.vue'

/*const MenuItem = {
  name: 'MenuItem',
  mixins: [
    LkChildBase
  ],
  components: {
    BackCallDialog
  }
}*/
import $ from "jquery";
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["client"]),
    items() {
      return ["Главная", "Оплата", "Смена тарифа"];
    },
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions(["fetchClient"]),
    menuClick() {
      document.getElementById("top-menu-toggler").click();
    },
    backCallClick() {
      this.$refs.backCallDialog.show();
    },
    expand() {
      $("#top-menu-toggler").toggleClass("on");
      $(".top-menu-expanded").slideToggle();
      $(".overlay").fadeToggle();
      $("body").toggleClass("no-scroll");
    },
  },
  created() {
    if (this.client === null) {
      this.fetchClient();
    }
  },
};
</script>
